<template>
  <div class="app">
    <vue-progress-bar></vue-progress-bar>
    <div class="container">
      <div class="vld-parent">
        <b-card header="<i class='fa fa-plus' ></i> Tambah File">
        <div class="col-12">
          <form action="" @submit.prevent="submit()" method="post">
              <div class="row">
                  <div class="col-8">
                      <b-form-fieldset label="No. BL/AWB">
                      <b-form-input :class="{'is-invalid': errors.has('No B/L')} " type="text" name="No B/L" id="ccnumber" placeholder="Nomor BL/AWB" v-validate="'required'" v-model="form.no_bl"></b-form-input>
                      <small class="text-danger" v-show="errors.has('No B/L')">
                        {{ errors.first('No B/L') }}
                      </small>                   
                      </b-form-fieldset>
                  </div>
                  <div class="col-4">
                      <b-form-fieldset label="Tanggal BL/AWB">
                      <b-form-input :class="{'is-invalid': errors.has('Tanggal B/L')}" type="date" name="Tanggal B/L" placeholder="Nomor BL/AWB" v-validate="'required'" v-model="form.tgl_bl"></b-form-input>
                      <small class="text-danger" v-show="errors.has('Tanggal B/L')">
                        {{ errors.first('Tanggal B/L') }}
                      </small>
                      </b-form-fieldset> 
                  </div>
              </div>
            <b-form-fieldset>
                <!-- <b-form-input type="file" @change="targetFiles"></b-form-input> -->
                <input type="file" name="file" v-validate="'required'" @change="targetFiles">
                <small class="text-danger" v-show="errors.has('file')">
                  {{ errors.first('file') }}
                </small>
            </b-form-fieldset>             
            <b-form-fieldset
              :horizontal="true">
              <b-form-radio
                :options="[
                  {text: 'Perusahaan Jasa Titipan',value: '1'},
                  {text: 'Agen Pengangkut',value: '2'}
                ]"
                v-validate="'required'"
                name="Jenis Perusahaan"
                v-model="form.jn_perusahaan"
                ></b-form-radio>
                <small class="text-danger" v-show="errors.has('Jenis Perusahaan')">
                  {{ errors.first('Jenis Perusahaan') }}
                </small>
            </b-form-fieldset>
            <b-form-fieldset
            :horizontal="true">
              <b-form-radio
                :options="[
                  {text: 'Luar Daerah Pabean ke Kawasan Bebas',value: '1'},
                  {text: 'Kawasan Bebas ke TLDDP',value: '2'}
                ]"
                v-validate="'required'"
                name="Tujuan"
                v-model="form.kd_tujuan"
                ></b-form-radio>
                <small class="text-danger" v-show="errors.has('Tujuan')">
                  {{ errors.first('Tujuan') }}
                </small>
            </b-form-fieldset>  
            
            <div class="row">
              <div class="col-6 pl-4" >
                <b-button type="submit" size="md" variant="success"><i class="fa fa-send"></i> Kirim</b-button>
              </div>
              <div class="ml-auto pr-4">
                <router-link to="/rekonmanifes/browse"> <button type="button" class="btn btn-secondary"><i class="fa fa-mail-reply"></i> Back</button></router-link>
                </div>
              </div>          
          </form>       
        </div>
        </b-card>

          <loading :active.sync="isLoading" 
          :is-full-page="false"></loading>
          
          <!-- <label><input type="checkbox" v-model="fullPage">Full page?</label> -->
          <!-- <button @click.prevent="doAjax">fetch Data</button> -->
      </div> 
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import swal from 'sweetalert'

export default {
  data () {
    return {
      isLoading: false,
      fullPage: false,
      form: {
        no_bl: '',
        tgl_bl: '',
        npwp: this.$store.getters['auth/user']['npwp'],
        file_bl: '',
        file_ex: '',
        jn_perusahaan: '',
        kd_tujuan: ''
      }
    }
  },
  components: {
    Loading
  },
  methods: {
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true
          this.$Progress.start()
          this.$http.post('rekonmanifes/upload', this.form)
            .then(response => {
              swal(response.data.status, response.data.message, response.data.status)
              this.isLoading = false
              this.$Progress.finish()
              this.$router.push('/rekonmanifes/browse')
            })
        }
      })
    },
    targetFiles (e) {
    //   this.form.file_bl = e.target.files[0]
      var fileReader = new FileReader()
      this.form.file_ex = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = (e) => {
        this.form.file_bl = e.target.result
      }
    }
    // onCancel () {
    //   console.log('User cancelled the loader.')
    // }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/RekonManifes/addbl.vue?5960f6ed